import { EarningsForEntityResults, earnings } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_EARNINGS = 'QUERY_KEY_EARNINGS';

export const createEarningsDataQueryOptions = (entityTag: string) => {
  const { path } = earnings.getEarningsForEntity;
  return queryOptions({
    queryKey: [QUERY_KEY_EARNINGS, entityTag] as const,
    queryFn: ({ signal }) =>
      wretchRequest<EarningsForEntityResults>(path(entityTag), {
        signal,
      }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!entityTag,
    select: (data: EarningsForEntityResults) => ({
      earnings: data?.earnings ?? [],
      earningExchange: data?.exchange ?? '',
    }),
  });
};

export const useEarningsData = (entityTag: string) =>
  useQuery(createEarningsDataQueryOptions(entityTag));
